import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Col, Form, Radio, Row, Spin } from "antd";
import { useForm } from "react-hook-form";
import { InputField, InputPhone } from "../../../../../atoms/FormFields";
import { useState } from "react";
import { createClientContact } from "../../../ducks/services";
import SuccessMessage from "../../../../../atoms/Toasts/SuccessMessage";
import { AxiosError, AxiosResponse } from "axios";
import ErrorMessage from "../../../../../atoms/Toasts/ErrorMessage";
import { useAppDispatch } from "../../../../../config/hooks";
import { getClientContacts } from "../../../ducks/actions";

const antIcon = <Loading3QuartersOutlined spin />;

interface FormValues {
  first_name: string;
  last_name: string;
  phone: string;
  email: string;
  title: string;
  preferred_method_of_contact: string;
}

interface PropsType {
  onClose: () => void;
  companyId: string;
  clientId: string | null;
}

export default function AddContactPopUp(props: PropsType) {
  const { onClose, companyId, clientId } = props;
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const [methodContact, setMethodContact] = useState("any");
  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm<FormValues>();

  const onSubmit = (val: FormValues) => {
    setLoading(true);

    const payload = {
      client_id: clientId as string,
      company_id: companyId,
      phone: val?.phone,
      first_name: val?.first_name,
      last_name: val?.last_name,
      title: val?.title,
      email: val?.email,
      preferred_method_of_contact: val?.preferred_method_of_contact,
      is_starred: false,
      is_signing: false,
      is_billing: false,
      is_contractor: false,
    };

    createClientContact(payload)
      .then((res: AxiosResponse) => {
        setLoading(false);
        SuccessMessage("New client added.");
        dispatch(getClientContacts(res?.data?.client_id as string));
        onClose();
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <Form
        layout="vertical"
        onFinish={handleSubmit(onSubmit)}
        autoComplete="off"
        name="dependencies"
      >
        <div className="modalWrapper addContactModal">
          <div className="modal_header">
            <div className="title">
              <h3>Add new contact</h3>
            </div>
          </div>

          <div className="modal_content">
            <Row gutter={16}>
              <Col span={12}>
                <InputField
                  fieldName="first_name"
                  label="First name"
                  control={control}
                  iProps={{
                    placeholder: "Enter first name",
                  }}
                  isRequired
                  rules={{
                    required: "First name is required.",
                  }}
                  validate={errors.first_name && "error"}
                  validMessage={errors.first_name && errors.first_name.message}
                />
              </Col>

              <Col span={12}>
                <InputField
                  fieldName="last_name"
                  label="Last name"
                  control={control}
                  iProps={{
                    placeholder: "Enter last name",
                  }}
                  isRequired
                  rules={{
                    required: "Last name is required.",
                  }}
                  validate={errors.last_name && "error"}
                  validMessage={errors.last_name && errors.last_name.message}
                />
              </Col>
              <Col span={24}>
                <InputField
                  fieldName="title"
                  label="Title"
                  control={control}
                  iProps={{
                    placeholder: "Enter title",
                  }}
                  // isRequired
                  // rules={{
                  //   required: "Title name is required.",
                  // }}
                  // validate={errors.title && "error"}
                  // validMessage={errors.title && errors.title.message}
                />
              </Col>
              <Col span={12}>
                <InputPhone fieldName="phone" label="Phone" control={control} />
              </Col>
              <Col span={12}>
                <InputField
                  fieldName="email"
                  label="Email"
                  control={control}
                  iProps={{
                    placeholder: "Enter email",
                  }}
                  rules={{
                    pattern: {
                      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                      message: "Please enter a valid email address.",
                    },
                  }}
                  validate={errors.email && "error"}
                  validMessage={errors.email && errors.email.message}
                />
              </Col>
              <Col span={24} style={{ display: "flex" }}>
                <div>Preferred method of contact:</div>
                <div className="preferredMethodRadio">
                  <Radio.Group
                    onChange={(e) => setMethodContact(e.target.value)}
                    value={methodContact}
                  >
                    <Radio value="any">Any</Radio>
                    <Radio value="phone">Phone</Radio>
                    <Radio value="email">Email</Radio>
                  </Radio.Group>
                </div>
              </Col>
            </Row>
          </div>

          <div className="modal_footer" style={{ justifyContent: "flex-end" }}>
            <Button
              htmlType="button"
              type="default"
              size="large"
              className="outlined-btn"
              onClick={onClose}
            >
              Cancel
            </Button>

            <Button
              htmlType="submit"
              type="primary"
              size="large"
              className="mint-btn"
              // disabled={!isDirty || !isValid}
            >
              Save contact
            </Button>
          </div>
        </div>
      </Form>
    </Spin>
  );
}
